import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// One-time global defaults (recessive muted-ink text; fill the fixed-height
// container instead of Chart.js's aspect-ratio sizing so cards stay uniform).
Chart.defaults.color = "#6B7280"
Chart.defaults.font.family =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
Chart.defaults.maintainAspectRatio = false

// Renders a Chart.js chart from a JSON config in data-chart-config-value.
// The controller is generic — all chart type/data/options live in the config,
// assembled server-side (see the analytics view).
export default class extends Controller {
  static values = { config: Object }
  static targets = ["canvas"]

  connect() {
    this.chart = new Chart(this.canvasTarget, this.configValue)
  }

  disconnect() {
    this.chart?.destroy()
  }
}
